import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CloudinaryImage from "../Common/CloudinaryImage";

function BlogImage({ src, alt, ...props }) {
  const theme = useTheme();

  const renderImage = () => {
    if (src.startsWith("http")) {
      return (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={src} alt={alt} {...props} />
      );
    }

    return <CloudinaryImage src={src} alt={alt} {...props} />;
  };

  return (
    <Box
      sx={{
        margin: "0 auto",
        marginY: 4,
        width: "fit-content",
        display: "flex",
        overflow: "hidden",
        borderRadius: 2,
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
      component="span"
    >
      {renderImage()}
    </Box>
  );
}

export default BlogImage;
